import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {T} from 'react-polyglot-hooks';
import useRouter from 'use-react-router';
import {GroupMemberRoleTypes} from '../../../graphql/groups.datatypes';
import getGroupMembersNoRoom from './getGroupMembersNoRoom.api';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GroupMembersNoRoom = (props: { className?: string }) => {
  const {className, ...rest} = props;
  const classes = useStyles();
  const {history} = useRouter();
  const groupMembersData = getGroupMembersNoRoom();

  return (
      <Card
          {...rest}
          className={clsx(classes.root, className)}
      >
        <CardHeader title="Group Members Without Room"/>
        <Divider/>
        <CardContent className={classes.content}>
          <PerfectScrollbar>
            <div className={classes.inner}>
              {groupMembersData.loading && (
                  <Typography><T phrase="Loading..."/></Typography>
              )}
              {!groupMembersData.loading &&
              groupMembersData.data &&
              groupMembersData.data.groupMembersNoRoom && (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>First Name</TableCell>
                        <TableCell>Last Name</TableCell>
                        <TableCell>Email</TableCell>
                        <TableCell>Group</TableCell>
                        <TableCell>Role</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {groupMembersData.data.groupMembersNoRoom.map(groupMember => {
                        return (
                            <TableRow
                                hover
                                key={groupMember.id}
                                onClick={() => history.push('/groupmembers/' + groupMember.id)}
                            >
                              <TableCell>{groupMember.first_name}</TableCell>
                              <TableCell>{groupMember.last_name}</TableCell>
                              <TableCell>{groupMember.email}</TableCell>
                              <TableCell>{groupMember.group!.name}</TableCell>
                              <TableCell>{GroupMemberRoleTypes[groupMember.group_role].name}</TableCell>

                            </TableRow>
                        )
                      })}
                    </TableBody>
                  </Table>
              )}
            </div>
          </PerfectScrollbar>

        </CardContent>
      </Card>
  );
};

export default GroupMembersNoRoom;
